import React from 'react';

// Like React.lazy, but with preload(): src/index.js loads the current page's
// chunk before hydrating, so the first render never suspends and React can
// reuse the prerendered HTML instead of replacing it.
export default function lazyPage(loader) {
  let Component = null;
  let promise = null;

  const preload = () => {
    if (!promise) {
      promise = loader().then((module) => {
        Component = module.default;
        return Component;
      });
    }
    return promise;
  };

  const LazyPage = (props) => {
    if (Component) return <Component {...props} />;
    throw preload(); // suspends until the chunk arrives (client-side navigation)
  };
  LazyPage.preload = preload;
  return LazyPage;
}
